<h2 mat-dialog-title>Position Details</h2>


  <mat-dialog-content>
      <div class="dialog-content-container">
      <app-text-input label="Job Title" [control]="positionForm.controls.jobTitle"></app-text-input>
      <app-text-input label="Base Salary" type="number" prefix="$" [control]="positionForm.controls.salary" [errorMsg]="'Numbers only'"></app-text-input>

      <app-radio-input [control]="positionForm.controls.isAdvertised" label="Has the position been advertised"
        [options]="[{value: 'true', label: 'Yes'}, {value: 'false', label: 'No'}]">
      </app-radio-input>

      <app-radio-input [control]="positionForm.controls.applicantKnown"
        label="Do you know the details of the visa applicant who would fill this position?"
        [options]="[{value: 'true', label: 'Yes'}, {value: 'false', label: 'No'}]">
      </app-radio-input>

      @if (positionForm.controls.applicantKnown.value == 'true') {

      <app-select-input label="Title" [control]="positionForm.controls.title" [lookupItems]="titles" placeholder="Select a Title"></app-select-input>
      @if (positionForm.controls.title.value?.value == 'Other') {
      <app-text-input label="Please specify title" [control]="positionForm.controls.titleOther"></app-text-input>
      }

      <app-text-input label="Given Names" [control]="positionForm.controls.firstName"></app-text-input>
      <app-text-input label="Surname / Family Name" [control]="positionForm.controls.surname"></app-text-input>
      <app-date-input [label]="'Date of Birth'" [control]="positionForm.controls.dob"></app-date-input>
      
      <hr><br>

      <app-select-input label="Country of Passport?" [control]="positionForm.controls.passportCountry"
        [lookupItems]="countries" placeholder="Select a Country">
      </app-select-input>

      <app-text-input [control]="positionForm.controls.passportNumber" label="Passport Number"></app-text-input>

      <app-select-input label="Marital Status" [control]="positionForm.controls.maritalStatus"
        [lookupItems]="maritalStatus" placeholder="Select a Marital Status">
      </app-select-input>

      <app-select-input [control]="positionForm.controls.education" [lookupItems]="educationLevels"
        label="What is the highest level of education achieved by this person?" placeholder="Select an Education Level"></app-select-input>

      <app-radio-input [control]="positionForm.controls.currentlyEmployed"
        label="Is this person currently employed in this position?"
        [options]="[{value: 'true', label: 'Yes'}, {value: 'false', label: 'No'}]">
      </app-radio-input>


      }
      </div>
  </mat-dialog-content>


<mat-dialog-actions align="end">
  <button mat-flat-button type="button" (click)="close()">OK</button>
  <button mat-flat-button type="button" class="cancel-button" (click)="cancel()">Cancel</button>
</mat-dialog-actions>